import type { CSSProperties } from "react";

import { cn } from "../../lib/cn";

type AvatarSize = "sm" | "md";

const sizeClassNames: Record<AvatarSize, string> = {
	sm: "size-[26px] text-[9.6px]",
	md: "size-[30px] text-[11px]",
};

export interface AvatarProps {
	readonly initials: string;
	readonly size?: AvatarSize;
	/** Gradient stops as CSS colors, e.g. `"var(--people)"`. */
	readonly from?: string;
	readonly to?: string;
}

/** Decorative initials disc; always render the person's name next to it. */
export function Avatar({ initials, size = "md", from = "var(--people)", to = "var(--legal)" }: AvatarProps) {
	const style: CSSProperties = { background: `linear-gradient(135deg, ${from}, ${to})` };
	return (
		<span
			aria-hidden="true"
			className={cn(
				"flex shrink-0 items-center justify-center rounded-full font-medium text-white",
				sizeClassNames[size],
			)}
			style={style}
		>
			{initials}
		</span>
	);
}
